module.exports = __webpack_public_path__ + "static/OP8-4edded95b6a8ff18a5b8577fd9a92e52.png";